import { IStringToString } from '../interfaces/core';
import { action, makeObservable, observable } from 'mobx';

class TranslationStore {

  translations: IStringToString = {
    MAX: 'Max',
    ALL_IN: 'All In',
    MATCH: 'Match',
    PAYS: 'Pays',
    PLACE_YOUR_BET: 'PLACE YOUR BET',
    CURRENT_BETS_TOTAL_BETS_COUNT: 'Total bets count',
    CURRENT_BETS_TOTAL_BETS_AMOUNT: 'Total bets amount',
    CURRENT_BETS_TICKET_BET: 'Bet {0}',
    CURRENT_BETS_TICKET_WIN: 'Win {0}',
    CURRENT_BETS_NO_BETS: 'NO BETS',
    CURRENT_BETS_PLEASE_PLACE_YOUR_BET: 'Please place your bet',
    FAIRNESS_MODAL_FAIRNESS: 'FAIRNESS',
    FAIRNESS_MODAL_KEY: 'Key',
    FAIRNESS_MODAL_SALT: 'Salt',
    FAIRNESS_MODAL_HASH: 'Hash',
    FAIRNESS_MODAL_PASTE_KEY: 'Paste key',
    FAIRNESS_MODAL_PASTE_SALT: 'Paste salt',
    FAIRNESS_MODAL_CHECK: 'CHECK',
    FAIRNESS_MODAL_CHECK_HASH_CODE: 'CHECK HASH CODE',
    FAIRNESS_MODAL_ABOUT_HASH_CODE: 'About Hash Code',
    FAIRNESS_MODAL_ABOUT_HASH_CODE_TEXT: 'About Hash Code text',
    LEFT_SIDEBAR_CURRENT_BETS: 'Current Bets',
    LEFT_SIDEBAR_HISTORY: 'History',
    RIGHT_SIDEBAR_RESULTS: 'Results',
    RIGHT_SIDEBAR_STATISTICS: 'Statistics',
    ARE_YOU_SURE_YOU_WANT_TO_REBET: 'ARE YOU SURE YOU WANT TO REBET ?',
    DO_NOT_SHOW_AGAIN: 'Don’t show again',
    REBET_NO: 'NO',
    REBET_YES: 'YES',
    BET: 'BET',
    HISTORY_REPEAT_ALL_BETS: 'Repeat all Bets',
    HISTORY_ROUND_ID: 'Round Id',
    HISTORY_TOTAL_BETS_COUNT: 'Total bets count',
    HISTORY_TOTAL_BETS_AMOUNT: 'Total bets amount',
    HISTORY_TOTAL_WIN: 'Total win',
    HISTORY: 'HISTORY',
    HISTORY_YOU_DO_NOT_HAVE_HISTORY: 'You don\'t have history',
    KEYPAD_BET_AMOUNT: 'BET AMOUNT',
    KEYPAD_OK: 'OK',
    KEYPAD_MIN: 'MIN',
    KEYPAD_MAX: 'MAX',
    PAY_TABLE: 'Pay Table',
    YOU_WIN: 'YOU WIN',
    RULES: 'Rules',
    RULES_PLEASE_ROTATE_YOUR_DEVICE: 'Please rotate your device',
    RULES_GAME_LIMITS: 'Game Limits',
    RULES_GAME_LIMITS_DESCRIPTION: 'Min Bet = {0}\nMax Bet = {1}\nMax Win = {2}',
    RULES_GAME_DESCRIPTION: 'Game Description',
    RULES_GAME_DESCRIPTION_INFO: 'Game Description Info',
    RULES_HOW_TO_PLAY: 'How to Play',
    RULES_HOW_TO_PLAY_DESCRIPTION: 'How to Play description',
    RULES_PAYMENTS: 'Payments',
    RULES_PAYMENTS_DESCRIPTION: 'Payments description',
    NOTIFICATION_PLEASE_SELECT_NUMBER: 'Please select number',
    NOTIFICATION_REACHED_MAX_SELECT_NUMBER: 'Reached max select number',
    NOTIFICATION_REACHED_MAX_AMOUNT: 'Reached max amount',
    NOTIFICATION_REACHED_MIN_AMOUNT: 'Reached min amount',
    NOTIFICATION_INSUFFICIENT_FUNDS: 'Insufficient funds',
    NOTIFICATION_YOUR_BET_IS_ACCEPTED: 'Your bet is accepted',
    NOTIFICATION_YOUR_BET_IS_UPDATED: 'Your bet is updated',
    INVALID_AMOUNT: 'Invalid amount',
    INVALID_ROUND: 'Invalid round',
    INVALID_ROOM: 'Invalid room',
    TRY_AGAIN: 'Try again',
    InvalidBet: 'Invalid bet',
    GAME_IS_UNAVAILABLE: 'Game is unavailable',
    SOMETHING_WENT_WRONG: 'Something went wrong',
    LAST_RESULTS_UPCOMING: 'Upcoming',
    LAST_RESULTS_CURRENT: 'Current',
    LAST_RESULTS_ROUND_ID: 'Round Id {0}',
    GAMES: 'Games',
  };

  constructor() {
    makeObservable(this, {
      translations: observable,
      setTranslations: action,
    })
  }

  setTranslations = (translations: IStringToString) => {
    this.translations = translations;
  }

  getTranslation = (key: string, ...params: (string | number)[]) => {
    let result = this.translations[key];
    if (result) {
      for (let i = 0; i < params.length; i++) {
        result = result.split('{' + i + '}').join(params[i].toString());
      }

      return result;
    }

    return key;
  }

}

export const translationStore = new TranslationStore();

export const useTranslation = () => translationStore.getTranslation;
